import React from "react";
import { brand, navLinks } from "../mock";
import { Instagram, Music2, Mail, ArrowUp } from "lucide-react";

const Footer = () => {
  return (
    <footer className="relative bg-[#08050F] text-[#EDE3D0] overflow-hidden">
      <div className="stars opacity-60" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full overflow-hidden ring-1 ring-[#D4A85B]/50 bg-[#6b1fb0]">
                <img
                  src={brand.logo}
                  alt="Mindful Matters logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="font-script text-[34px] leading-none pt-1">{brand.name}</div>
                <div className="text-[9px] uppercase tracking-[0.24em] text-[#D4A85B]/85 whitespace-nowrap mt-1.5">{brand.submark}</div>
              </div>
            </div>
            <p className="mt-6 text-[#EDE3D0]/70 max-w-md leading-relaxed">
              A spiritual + psychological healing space held by Devona Nicole Hazelwood —
              LPC · NCC · Reiki Master · Author · Transformational Coach.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <a href={brand.instagram} className="w-10 h-10 rounded-full border border-[#D4A85B]/40 flex items-center justify-center hover:bg-[#D4A85B] hover:text-[#0A0714] transition">
                <Instagram size={15} />
              </a>
              <a href={brand.tiktok} className="w-10 h-10 rounded-full border border-[#D4A85B]/40 flex items-center justify-center hover:bg-[#D4A85B] hover:text-[#0A0714] transition">
                <Music2 size={15} />
              </a>
              <a href={`mailto:${brand.email}`} className="w-10 h-10 rounded-full border border-[#D4A85B]/40 flex items-center justify-center hover:bg-[#D4A85B] hover:text-[#0A0714] transition">
                <Mail size={15} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4A85B]/85">Explore</div>
            <ul className="mt-5 space-y-3">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-[#EDE3D0]/80 hover:text-[#D4A85B] transition">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4A85B]/85">Weekly love-letters</div>
            <p className="mt-4 text-[#EDE3D0]/70">A quiet Sunday note on healing, energy and coming home. No spam — ever.</p>
            <form onSubmit={(e) => e.preventDefault()} className="mt-4 flex gap-2">
              <input
                type="email"
                placeholder="you@email.com"
                className="flex-1 bg-transparent border border-[#D4A85B]/30 focus:border-[#D4A85B] rounded-full px-4 py-2.5 text-sm outline-none text-[#EDE3D0] placeholder-[#EDE3D0]/40"
              />
              <button className="rounded-full bg-[#D4A85B] text-[#0A0714] px-5 text-[11px] uppercase tracking-[0.24em] hover:bg-[#E9C77B] transition">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#D4A85B]/15 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#EDE3D0]/60">
          <div>© {new Date().getFullYear()} Mindful Matters Counseling & Coaching. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-[#D4A85B]">Privacy</a>
            <a href="#" className="hover:text-[#D4A85B]">Terms</a>
            <a href="#top" className="inline-flex items-center gap-1.5 hover:text-[#D4A85B]">
              Back to top <ArrowUp size={12} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
